import React from 'react';
interface LocationGalleryProps {
  images: string[];
  locationName: string;
}
export function LocationGallery({
  images,
  locationName
}: LocationGalleryProps) {
  if (!images || images.length === 0) {
    return null;
  }
  const isSingleImage = images.length === 1;
  return <section className="py-16 bg-slate-50" data-id="element-563">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-564">
        <h2 className="text-3xl font-bold text-[#1a2332] mb-8 text-center" data-id="element-565">
          Our {locationName} Facility
        </h2>

        <div className={`grid ${isSingleImage ? 'grid-cols-1 justify-items-center' : 'grid-cols-1 md:grid-cols-2'} gap-6`} data-id="element-566">
          {images.map((image, index) => <div key={index} className={`relative aspect-[4/3] rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow ${isSingleImage ? 'max-w-2xl w-full' : ''}`} data-id="element-567">
              <img src={image} alt={`${locationName} facility view ${index + 1}`} className="w-full h-full object-cover" data-id="element-568" />
            </div>)}
        </div>
      </div>
    </section>;
}